import { getPathname, PpHero } from "@italymondo/core-ui";
import { CMSHeroData } from "./query";

export function formatData(data: CMSHeroData, showAlertBar: boolean): PpHero {
  if (!data) {
    throw new Error("Expected a site object");
  }

  return {
    description: data?.founderPage[0].heroDescription || "",
    hasAlertBar: showAlertBar && !!data?.founderPage[0].alertBar,
    headline: data?.founderPage[0].heroHeadline || "",
    heroType: data?.founderPage[0].heroType,
    imageSrc: data?.founderPage[0].heroImage?.urlSharp || "",
    primaryButton: data?.founderPage[0]?.heroPrimaryButton
      ? {
          title: data?.founderPage[0].heroPrimaryButton?.title,
          url: getPathname(data?.founderPage[0]?.heroPrimaryButton?.page?.url),
        }
      : null,
    secondaryButton: data?.founderPage[0]?.heroSecondaryButton
      ? {
          title: data?.founderPage[0]?.heroSecondaryButton?.title,
          url: getPathname(
            data?.founderPage[0]?.heroSecondaryButton?.page?.url
          ),
        }
      : null,
    verticalText: data?.founderPage[0].heroVerticalText?.name || "",
  };
}
